import "./css/pdf-viewer.css";

function PdfViewer({ mergeFilePath }) {
  return (
    <div className="pdf-viewer">
      <h1>Your Merged PDF FILE</h1>
      <iframe title="iframe" src={mergeFilePath} width="800" height="600" />
    </div>
  );
}

export default PdfViewer;
